import React from 'react'
import { Checkbox } from 'antd'
import { CompanyListDiv } from '../../../style'

const RuleFilter = ({
  handleRulesCheckboxChange,
  selectedRules,
  rulesDatas,
}) => {
  return (
    <CompanyListDiv style={{ marginTop: '10%' }}>
      {rulesDatas.map(({ label, value }) => (
        <Checkbox
          style={{ margin: '0px' }}
          key={value}
          onChange={() => handleRulesCheckboxChange(value)}
          checked={selectedRules?.includes(value)}
        >
          <span
            style={{ color: label?.includes('Lower Comp.') ? 'red' : 'black' }}
          >
            {label}
          </span>
        </Checkbox>
      ))}
    </CompanyListDiv>
  )
}

export default RuleFilter
